import { render, staticRenderFns } from "./ProductResultsSection.vue?vue&type=template&id=4e28ae9a&"
import script from "./ProductResultsSection.vue?vue&type=script&lang=js&"
export * from "./ProductResultsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports